var map = {
	"./legal/pages/review": [
		53590,
		6321,
		894,
		9300,
		768,
		8839,
		5443,
		3085,
		5702,
		2954,
		7137,
		804,
		8150,
		1192,
		9565,
		9887,
		8360,
		5184,
		4755,
		4765,
		5188
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5488;
module.exports = webpackAsyncContext;